import { computed, type ComputedRef } from 'vue'

import { Seasons } from '@collector/sportsapi-client'

import { useSeasonDetailsQuery } from './queries/useSeasonDetailsQuery'

export type SeasonDetailsMap = Map<
  Seasons.Details.SeasonDetail['detail_id'],
  Seasons.Details.SeasonDetail['detail_value']
>

export function useSeasonDetails(): {
  seasonDetailsMap: ComputedRef<SeasonDetailsMap>
} {
  const { data: seasonDetails } = useSeasonDetailsQuery()

  const seasonDetailsMap = computed(() => {
    const map: SeasonDetailsMap = new Map()
    for (const detail of seasonDetails.value ?? []) {
      map.set(detail.detail_id, detail.detail_value)
    }
    return map
  })

  return { seasonDetailsMap }
}
